import axios from "axios";
import moment from "moment";
import { randomstring } from "randomstring-js";
import {
  getRequest,
  postRequest,
  patchRequest,
  deleteRequest,
  uploadEncodedFile,
} from "NetworkCall";
import {
  itemCount,
  INSTANCE_URL,
  ONE_SIGNAL_KEY,
  ONE_SIGNAL_ID,
  DATE_FORMAT_WITH_TIME,
  BASE_IMAGES_URL,
  APP_API_KEY,
} from "Constants";

export var DASHBOARD_NOTIFICATION_LIST = "DASHBOARD_NOTIFICATION_LIST";
export var DASHBOARD_SCHEDULED_NOTIFICATION_LIST =
  "DASHBOARD_SCHEDULED_NOTIFICATION_LIST";
export const CHOOSE_USER_MODAL = "CHOOSE_USER_MODAL";
export const DASHBOARD_USER_LIST_WITHOUT_ADMIN =
  "DASHBOARD_USER_LIST_WITHOUT_ADMIN";
export var DASHBOARD_NOTIFICATION_CREATE_MODAL =
  "DASHBOARD_NOTIFICATION_CREATE_MODAL";
export var DASHBOARD_NOTIFICATION_VIEW_MODAL =
  "DASHBOARD_NOTIFICATION_VIEW_MODAL";

export function fetchDashboardNotificationList(
  session,
  pageCount = 0,
  callback
) {
  var perPage = itemCount;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;

  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;
  var postData = {
    eventid: session.eventid,
    limit: perPage,
    offset: offset,
    type: "fetchNotification",
  };
  return (dispatch) => {
    postRequest(
      url,
      postData,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: DASHBOARD_NOTIFICATION_LIST,
          payload: { resource: data.response, count: data.count },
        });
        dispatch({
          type: DASHBOARD_SCHEDULED_NOTIFICATION_LIST,
          payload: {
            resource: data.responseschedule,
            count: data.countSchedule,
          },
        });
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };

  // var url = `${INSTANCE_URL}/api/v2/eventify/_table/notifications?order=notificationid%20DESC&limit=${perPage}&offset=${offset}&include_count=true&filter=eventid=${session.eventid}`;
  // return (dispatch) => {
  //   getRequest(url, session, dispatch, (response) => {
  //     dispatch({type: DASHBOARD_NOTIFICATION_LIST, payload: response});
  //   }, (error) => {
  //   });
  // }
}

export function searchDashboardNotificationList(
  session,
  pageCount = 0,
  search,
  callback
) {
  var perPage = itemCount;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;

  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;
  var postData = {
    eventid: session.eventid,
    search: search,
    limit: perPage,
    offset: offset,
    type: "fetchNotification",
  };
  return (dispatch) => {
    postRequest(
      url,
      postData,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: DASHBOARD_NOTIFICATION_LIST,
          payload: { resource: data.response, count: data.count },
        });
        dispatch({
          type: DASHBOARD_SCHEDULED_NOTIFICATION_LIST,
          payload: {
            resource: data.responseschedule,
            count: data.countSchedule,
          },
        });
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
}

export function openChooseUserModal(showModal) {
  return { type: CHOOSE_USER_MODAL, payload: showModal };
}

export function clearUserExceptAdmin() {
  return (dispatch) => {
    dispatch({
      type: DASHBOARD_USER_LIST_WITHOUT_ADMIN,
      payload: {},
    });
  };
}

export function fetchUserExceptAdmin(session, pageCount = 0, callback) {
  var perPage = itemCount;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `limit=${itemCount}&offset=${offset}`;
  // var filter = encodeURI(`((eventid=${session.eventid})AND(isactive=1)AND(userwaitlistmode=0)AND(isadmin=0))`);   Previously was not showing admin user
  var filter = encodeURI(
    `(eventid=${session.eventid})AND(isactive=1)AND(userwaitlistmode=0)`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?include_count=true&admin=1&filter=(${filter})&${offSetQuery}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: DASHBOARD_USER_LIST_WITHOUT_ADMIN,
          payload: { data: response.resource, count: response.meta.count },
        });
        callback({
          success: 1,
          data: response.resource,
          count: response.meta.count,
        });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function searchUserOutreach(
  session,
  search = "",
  pageCount = 0,
  callback
) {
  var perPage = itemCount;
  var offset = pageCount == 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `limit=${itemCount}&offset=${offset}`;
  var searchQuery = `(email like %${search}%)OR(username like %${search}%)`;
  var filter = encodeURI(
    `(eventid=${session.eventid})AND(isactive=1)AND(userwaitlistmode=0)AND(${searchQuery})`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?include_count=true&admin=1&filter=(${filter})&${offSetQuery}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: DASHBOARD_USER_LIST_WITHOUT_ADMIN,
          payload: {
            success: 1,
            data: response.resource,
            count: response.meta.count,
          },
        });
        callback({ data: response.resource, count: response.meta.count });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function outreachCreateModal(obj) {
  return { type: DASHBOARD_NOTIFICATION_CREATE_MODAL, payload: obj };
}

export function fetchAssociated(session, values, callback) {
  //debugger;
  var url = `${INSTANCE_URL}/api/v2/eventifyscript/outreachAssociateSearch`;
  var body = {
    eventid: session.eventid,
    searchkey: values.search,
  };
  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        if (response.is_error == 0) {
          callback({ success: 1, resource: response.result });
        } else {
          callback({ success: 0 });
        }
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function sendNotificationDirect(session, values, users, callback) {
  var usersCount = users.length;
  var filters = [];
  if (values.category === "specific") {
    users.map((user, index) => {
      if (users.length == 1) {
        filters.push({
          field: "tag",
          key: "appuserid",
          relation: "=",
          value: user.appuserid,
        });
      } else {
        if (index == 0) {
          filters.push(
            {
              field: "tag",
              key: "appuserid",
              relation: "=",
              value: user.appuserid,
            },
            { operator: "OR" }
          );
        } else {
          if (index < users.length - 1) {
            filters.push(
              {
                field: "tag",
                key: "eventid",
                relation: "=",
                value: session.eventid,
              },
              {
                field: "tag",
                key: "appuserid",
                relation: "=",
                value: user.appuserid,
              },
              { operator: "OR" }
            );
          } else {
            filters.push(
              {
                field: "tag",
                key: "eventid",
                relation: "=",
                value: session.eventid,
              },
              {
                field: "tag",
                key: "appuserid",
                relation: "=",
                value: user.appuserid,
              }
            );
          }
        }
      }
    });
  } else if (values.category !== "specific" && values.category !== "all") {
    filters.push({
      field: "tag",
      key: values.category,
      relation: "=",
      value: true,
    });
  }

  let pushimage = values.image ? values.image : "";
  var filename = `eventify/${session.eventid}/images/others/${randomstring(
    32
  )}.jpg`;

  // debugger;
  return (dispatch) => {
    if (usersCount > 0) {
      _uploadImage(session, pushimage, filename, dispatch, (imgres) => {
        values = {
          ...values,
          ...(imgres.data && imgres.data.path
            ? {
                image: imgres.data.path,
              }
            : { image: "" }),
        };

        if (values.option === "push_email") {
          dispatch(sendEmail(session, values, users, filters, callback));
        } else if (values.option === "push") {
          dispatch(fireOnesignalApi(session, values, users, filters, callback));
        } else {
          callback({ success: 3 });
        }
      });
    } else {
      callback({ success: 2 });
    }
  };
}

export function _uploadImage(session, imagedata, filename, dispatch, callback) {
  if (imagedata.search(";base64,") > 0) {
    imagedata = imagedata.replace(/^data:image\/[a-z]+;base64,/, "");
    var imageJson = {
      resource: [
        {
          name: filename,
          type: "file",
          is_base64: true,
          content: imagedata,
        },
      ],
    };

    uploadEncodedFile(
      `${BASE_IMAGES_URL}?check_exist=false`,
      session,
      imageJson,
      dispatch,
      (data) => {
        callback({ success: 1, data: data });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  } else {
    callback({ success: 1 });
  }
}

var sendEmail = (session, values, users, filters, callback) => {
  var emailUrl = `${INSTANCE_URL}/api/v2/eventify/_table/email_push_log`;
  let sentData = [];

  users.map((val, index) => {
    let playerid = val.playerid ? val.playerid : null;
    let obj = {
      eventid: session.eventid,
      logtype: "push",
      playerid: playerid,
      emailid: val.email,
      username: val.username,
      title: values.title,
      content: values.content,
      image: values.image,
      redirectto: values.redirectto ? values.redirectto : null,
      redirectvalue: values.redirectvalue ? values.redirectvalue : null,
      logstatus: "pending",
      createdbyid: session.userid,
    };
    sentData.push(obj);
  });

  var body = { resource: sentData };

  return (dispatch) => {
    postRequest(
      emailUrl,
      body,
      session,
      dispatch,
      (response) => {
        dispatch(fireOnesignalApi(session, values, users, filters, callback));
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
};

var fireOnesignalApi = (session, values, users, filters, callback) => {
  var url = "https://onesignal.com/api/v1/notifications";
  const one_signal_id = session.onesignalid
    ? session.onesignalid
    : ONE_SIGNAL_ID;
  const one_signal_key = session.onesignalkey
    ? session.onesignalkey
    : ONE_SIGNAL_KEY;

  var headers = {
    "Content-Type": "application/json; charset=utf-8",
    Authorization: `Basic ${one_signal_key}`,
  };

  var payload = {
    // app_id: one_signal_id, // on this when call direct onsignal from clientside
    filters: [
      {
        field: "tag",
        key: "eventid",
        relation: "=",
        value: session.eventid,
      },
      ...filters,
    ],
    data: {
      type: "global_reach",
      internalsection: values.redirectto ? values.redirectto : null,
      internalvalue: values.redirectvalue ? values.redirectvalue : null,
    },
    headings: { en: values.title },
    contents: { en: values.content },
    ios_attachments: {
      id1:
        values.image != ""
          ? `${BASE_IMAGES_URL}/${values.image}?api_key=${APP_API_KEY}`
          : "",
    }, // Image attachment for ios
    big_picture:
      values.image != ""
        ? `${BASE_IMAGES_URL}/${values.image}?api_key=${APP_API_KEY}`
        : "", // Image attachment for android
  };

  if (values.redirectto === "external" && values.redirectvalue !== "") {
    payload.url = values.redirectvalue; // The URL to open in the browser when a user clicks on the notification.
  }

  return (dispatch) => {
    // axios
    //   .post(url, payload, { headers })
    //   .then(({ data }) => {
    //     dispatch(
    //       addNotificationOutreach(session, values, users, data, callback)
    //     );
    //   })
    //   .catch((error) => {
    //     callback({ success: 0, error: error });
    //   });

    url = `${INSTANCE_URL}/api/v2/sendOutreachNotification`;
    postRequest(
      url,
      {
        eventid: session.eventid,
        pushdata: payload,
        category: values.category, // with this will will check and get the user related to category.
      },
      session,
      dispatch,
      (data) => {
        // console.log("data :- ", data);
        dispatch(
          addNotificationOutreach(session, values, users, data, callback)
        );
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
};

export function addNotificationOutreach(
  session,
  values,
  users,
  data,
  callback
) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/notifications`;
  var batch = randomstring(32);
  let push_only = 1;
  if (values.option === "push_email") {
    push_only = 0;
  }
  var notificationdata = [];
  users.map((user) => {
    var obj = {
      eventid: session.eventid,
      title: values.title,
      notificationtext: values.content,
      image: values.image,
      sentto: user.appuserid,
      type: "outreach",
      redirectto: values.redirectto ? values.redirectto : null,
      redirectvalue: values.redirectvalue ? values.redirectvalue : null,
      onesignal_notificationid: JSON.stringify(data),
      recipients_count: data.recipients,
      batchno: batch,
      issent: 1,
      push_only: push_only,
      createdby: session.userid,
    };

    notificationdata.push(obj);
  });

  var payload = {
    resource: notificationdata,
  };

  return (dispatch) => {
    postRequest(
      url,
      payload,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function outreachViewModal(obj) {
  return { type: DASHBOARD_NOTIFICATION_VIEW_MODAL, payload: obj };
}

export function resetPushNotifications(session, callback) {
  var filter = encodeURI(
    `(eventid=${session.eventid})AND((type=outreach)OR(type=session))`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/notifications?filter=(${filter})`;
  return (dispatch) => {
    deleteRequest(
      url,
      session,
      dispatch,
      (data) => {
        callback({ error: 0 });
      },
      (error) => {
        callback({ error: 1, data: error });
      }
    );
  };
}

export function deletePushNotifications(session, data, callback) {
  var filter = encodeURI(
    `(eventid=${data.eventid})AND(batchno=${data.batchno})`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/notifications?filter=(${filter})`;
  return (dispatch) => {
    deleteRequest(
      url,
      session,
      dispatch,
      (data) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ error: 0, data: error });
      }
    );
  };
}

/*** Schedule push related ***/
export function sendNotificationScheduled(session, values, users, callback) {
  var usersCount = users.length;
  let pushimage = values.image ? values.image : "";
  var filename = `eventify/${session.eventid}/images/others/${randomstring(
    32
  )}.jpg`;

  var url = `${INSTANCE_URL}/api/v2/eventify/_table/notification_scheduled`;
  var batch = randomstring(32);
  let push_only = 1;
  if (values.option === "push_email") {
    push_only = 0;
  }
  var notificationdata = [];

  return (dispatch) => {
    if (usersCount > 0) {
      _uploadImage(session, pushimage, filename, dispatch, (imgres) => {
        var uploadimage =
          imgres.data && imgres.data.path ? imgres.data.path : "";

        users.map((user) => {
          var obj = {
            eventid: session.eventid,
            title: values.title,
            notificationtext: values.content,
            image: uploadimage,
            redirectto: values.redirectto ? values.redirectto : null,
            redirectvalue: values.redirectvalue ? values.redirectvalue : null,
            sentto: user.appuserid,
            schedule_time: values.scheduledate,
            push_only: push_only,
            batchno: batch,
          };

          notificationdata.push(obj);
        });

        var payload = {
          resource: notificationdata,
        };

        postRequest(
          url,
          payload,
          session,
          dispatch,
          (response) => {
            callback({ success: 1, data: response });
          },
          (error) => {
            callback({ success: 0, error: error });
          }
        );
      });
    } else {
      callback({ success: 2 });
    }
  };
}

export function cancelscheduleNotification(session, batchno, values, callback) {
  var body = { resource: { ...values } };

  var url = `${INSTANCE_URL}/api/v2/eventify/_table/notification_scheduled?filter=(batchno=${batchno})`;
  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
}

export function getNotificationDetails(
  session,
  signalnotificationid,
  notificationid,
  callback
) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;
  var postData = {
    eventid: session.eventid,
    signalnotificationid: signalnotificationid,
    notificationid: notificationid,
    type: "notificationdetails",
  };
  return (dispatch) => {
    postRequest(
      url,
      postData,
      session,
      dispatch,
      (data) => {
        if (data.success) {
          callback({ success: 1, response: data.result });
        } else {
          callback({ success: 0 });
        }
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
}
